import styled from 'styled-components';

/**
 * The Reel / Clip identity badge (PLAT-11246, PLAT-11249): a pill at the
 * mid-strength between the card tokens' 6% fill (built to be one quiet tag
 * among a grid) and a solid pill (which shouted) — a tinted fill, the
 * *saturated* base token as the text, and a soft border of the same hue.
 *
 * One component for every surface that says what a piece of content *is*: the
 * clip preview's title row and the clip grid's cards, so the purple "Reel"
 * reads as one mark everywhere. Sized like the cards' other pills (ThemeTag,
 * NewBadge — same font, same padding); a host with a tighter height budget
 * (the modal title row) overrides the box, never the palette.
 */
export const ClipTypeBadge = styled.span<{ $color: 'purple' | 'blue' }>`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 4px 12px;
  border-radius: 999px;
  background-color: ${props =>
    `color-mix(in srgb, var(--badge-${props.$color}) 18%, transparent)`};
  border: 1px solid
    ${props =>
      `color-mix(in srgb, var(--badge-${props.$color}) 45%, transparent)`};
  color: ${props => `var(--badge-${props.$color})`};
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  line-height: var(--leading-text-xs);
  white-space: nowrap;
`;

export default ClipTypeBadge;
